module.exports = __webpack_public_path__ + "media/admin/csclip_logo@2x-248c278e.png";